// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_cGv","cls2":"Cta-cls2_Rz7 Cta-cls1_cGv"};